import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  unassigned: [],
  isLoading: false,
  error: null,
};

const extractApiObject = (payload) => {
  if (payload?.data && !Array.isArray(payload.data)) {
    return payload.data;
  }

  return payload;
};

const upsertSensorInList = (list, sensor) => {
  if (!Array.isArray(list) || !sensor?.id) {
    return;
  }

  const sensorIndex = list.findIndex(
    (item) => String(item?.id) === String(sensor.id)
  );

  if (sensorIndex >= 0) {
    const previousSensor = list[sensorIndex];
    list[sensorIndex] = {
      ...previousSensor,
      ...sensor,
      sensor_type:
        typeof sensor.sensor_type === "object"
          ? sensor.sensor_type
          : previousSensor.sensor_type || sensor.sensor_type,
    };
    return;
  }

  list.push(sensor);
};

const removeSensorFromList = (list, sensorId) => {
  if (!Array.isArray(list) || !sensorId) {
    return;
  }

  const sensorIndex = list.findIndex(
    (item) => String(item?.id) === String(sensorId)
  );

  if (sensorIndex >= 0) {
    list.splice(sensorIndex, 1);
  }
};

const sensorsSlice = createSlice({
  name: "sensors",
  initialState,
  reducers: {
    fetchSensorsStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchSensorsSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    upsertSensorSuccess(state, action) {
      const sensor = extractApiObject(action.payload);

      if (!sensor?.id) {
        return;
      }

      if (Array.isArray(state.data?.data)) {
        upsertSensorInList(state.data.data, sensor);
      } else if (Array.isArray(state.data?.results)) {
        upsertSensorInList(state.data.results, sensor);
      } else if (Array.isArray(state.data)) {
        upsertSensorInList(state.data, sensor);
      }

      if (Array.isArray(state.unassigned?.data)) {
        removeSensorFromList(state.unassigned.data, sensor.id);
      } else if (Array.isArray(state.unassigned?.results)) {
        removeSensorFromList(state.unassigned.results, sensor.id);
      } else if (Array.isArray(state.unassigned)) {
        removeSensorFromList(state.unassigned, sensor.id);
      }
    },
    fetchUnassignedSensorsStart(state) {
      state.error = null;
    },
    fetchUnassignedSensorsSuccess(state, action) {
      state.unassigned = action.payload;
    },
    fetchSensorsFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    resetSensorsState(state) {
      state.data = [];
      state.unassigned = [];
      state.isLoading = false;
      state.error = null;
    },
  },
});

export const {
  fetchSensorsStart,
  fetchSensorsSuccess,
  upsertSensorSuccess,
  fetchUnassignedSensorsStart,
  fetchUnassignedSensorsSuccess,
  fetchSensorsFailure,
  resetSensorsState,
} = sensorsSlice.actions;
export default sensorsSlice.reducer;
